import "./Loader.scss";

const Loader = function(props) {
	return (
		<div className="loader"></div>
	)
}
export default Loader;